import { message } from 'antd';
import api from '../api';
import { QboVendor, Vendor, VendorItem } from './vendorsModel';

export const loadVendorsEndpoint = '/vendors'

export const getVendorsList = async (): Promise<VendorItem[]> => {
  return (await api.get<VendorItem[]>(loadVendorsEndpoint)).data
}

export const getActiveVendorsList = async (): Promise<VendorItem[]> => {
  return (await api.get<VendorItem[]>(`${loadVendorsEndpoint}/active`)).data
}

export const getQboVendorsList = async (unassignedOnly: boolean): Promise<QboVendor[]> => {
  const url = '/vendors/qbo'
  return (await api.get<QboVendor[]>(url, {
    params: {
      filterAssigned: unassignedOnly
    }
  })).data;
}

export const getVendorById = async (id?: number): Promise<Vendor> => {
  return (await api.get<Vendor>(`/vendors/${id}`)).data
}

export const saveVendor = async (addedVendor: Vendor): Promise<Vendor> => {
  try {
    return (await api.post<Vendor>('/vendors', addedVendor)).data
  } catch (e: any) {
    message.error(e.response.data.message)
    throw e
  }
}

export const importVendors = async (payload: QboVendor[]): Promise<void> => {
  try {
    await api.post('/vendors/qbo/import', payload)
  } catch (e: any) {
    message.error(e.response.data.message)
    throw e
  }
}

export const removeVendor = async (id: number): Promise<void> => {
  return api.delete(`/vendors/${id}`)
}